import { FC, memo } from 'react';
import ReactSelect from 'react-select';

import { PHONE_REACT_SELECT_COMPONENTS_OVERRIDES } from './constants/phoneReactSelectComponentsOverrides';
import { usePhoneCountrySelect } from './hooks/usePhoneCountrySelect';
import { PhoneCountrySelectOrDisplayProps } from './types/PhoneCountrySelectOrDisplayProps';
import { CountryCodeDisplay } from './CountryCodeDisplay';

const PhoneCountrySelectOrDisplayComponent: FC<
  PhoneCountrySelectOrDisplayProps
> = ({ countryCallingCode, hasStartElement, onChange }) => {
  const { selectedValue, onCountryChange, countryOptions } =
    usePhoneCountrySelect(countryCallingCode, onChange);

  if (countryOptions.length <= 1) {
    return (
      <CountryCodeDisplay
        code={selectedValue?.value ?? ''}
        ps={hasStartElement ? undefined : 4}
      />
    );
  }

  return (
    <ReactSelect
      components={PHONE_REACT_SELECT_COMPONENTS_OVERRIDES}
      defaultValue={selectedValue}
      isClearable={false}
      isDisabled={countryOptions.length <= 1}
      onChange={onCountryChange}
      options={countryOptions}
      placeholder=""
    />
  );
};

export const PhoneCountrySelectOrDisplay = memo(
  PhoneCountrySelectOrDisplayComponent,
);
